import pushNotifications from './pushNotifications.reducer';

export default { pushNotifications };
